/**
 *  Custom Validation Logic for vee-validate
 *
 *
 */

import {Validator} from 'vee-validate';
import EnvService from '@/services/EnvService';

import axios from 'axios';
import {i18n} from '../main'

// Make sure that company number is unuque
Validator.extend('uniqueCompany', {
    validate: (value) => {
        return axios.post(EnvService.serviceURL + '/service/check/company', value, {
            headers: {
                'Content-Type': 'text/plain',
            }
        }).then((response) => {
            return {
                valid: !response.data,
            };
        }).catch(error => {
            console.log(error)
            return {
                // in the case if we fail with a communication with the server we accept the value
                // and rely on the server validation on submit
                valid: true,
            };
        });
    },

    //eslint-disable-next-line
    getMessage(field, args) {
        var msg = i18n.t('attributes.accountNumberExists');
        return msg;
    }
});
